import { createSafeContext } from "@/shared/utils/createSafeContext";

interface MatchAllTermsContextValue {
    matchAllTermsExactly: boolean;
    matchAllTermsSupported: boolean;
    setMatchAllTermsExactly: (newValue: boolean) => void;
}

/**
 * Context provider for match-all-terms functionality at the features layer.
 * Provides needed context without business logic, following FSD architecture.
 */
const [MatchAllTermsProvider, useMatchAllTermsContext] =
    createSafeContext<MatchAllTermsContextValue>("MatchAllTermsContext");

export { MatchAllTermsProvider, useMatchAllTermsContext };
